// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_9w9m7","dbox":"index_dbox_6FlDm"};